import { useDataValue } from 'Simple/Data.js'

export default function useDataConfiguration(props) {
  let appointment_id = useDataValue({
    context: 'selected',
    path: 'event_execution_data.appointment_id',
    viewPath: props.viewPath,
  })

  return {
    variables: { appointment_id },
    pause: !appointment_id,
  }
}
